// extracted by mini-css-extract-plugin
export default {"root":"MainPage_root__sJ+7g","bg":"MainPage_bg__+HwKT","bgImg":"MainPage_bgImg__AOeRU","bgMb":"MainPage_bgMb__rkukl","bgDt":"MainPage_bgDt__5MaT0"};